// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3G0vU","col":"styles_col__3STXx"};